/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import {
  NavLink,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import RestoreFromTrashIcon from "@mui/icons-material/RestoreFromTrash";
import qs from "qs";
import SearchIcon from "@mui/icons-material/Search";

import {
  Alert,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider as MuiDivider,
  Grid,
  IconButton,
  Link,
  Paper as MuiPaper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { Add as AddIcon, Download } from "@mui/icons-material";
import { spacing } from "@mui/system";
import { withStyles } from "@mui/styles";
import axios from "../../CustomAxios";
import Loading from "../components/Loading";
import { connect } from "react-redux";
import ApCompanyFilter from "./ApCompanyFilter";
import { CSVLink } from "react-csv";
import moment from "moment";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);
const StyledTableContainer = withStyles((theme) => ({
  root: {},
}))(TableContainer);
const Spacer = styled.div`
  flex: 1 1 100%;
`;
const ToolbarTitle = styled.div`
  min-width: 150px;
`;

// Styled row for deleted companies
const DeletedTableRow = styled(TableRow)`
  opacity: 0.7;
  background-color: #fafafa;
`;

function createData(
  id,
  company_code,
  name,
  email,
  mobile,
  address_line_one,
  address_line_two,
  pincode,
  state,
  city,
  address,
  is_deleted
) {
  return {
    id,
    company_code,
    name,
    email,
    mobile,
    address_line_one,
    address_line_two,
    pincode,
    state,
    city,
    address,
    is_deleted,
  };
}

const headCells = [
  { key: "code", alignment: "left", label: "Company Code" },
  { key: "name", alignment: "left", label: "Company Name" },
  { key: "email", alignment: "left", label: "Email" },
  { key: "mobile", alignment: "left", label: "Phone Number" },
  { key: "address", alignment: "left", label: "Address" },
];

const getCompanies = async (
  authData,
  setLoader,
  setRows,
  sortingField,
  sortingOrder,
  search,
  page,
  limit,
  setTotal,
  includeDeleted
) => {
  try {
    setLoader(true);
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${
        authData?.type
      }/ap_company?sorting_field=${sortingField}&sorting_order=${sortingOrder}&search_keyword=${search}&page=${
        page + 1
      }&limit=${limit}&include_deleted=${includeDeleted}`,
      config
    );
    if (data.success) {
      const companies = data.data.data;
      setTotal(data.data.metadata.total_results);

      let rows = [];
      companies.forEach((company) => {
        rows.push(
          createData(
            company._id,
            company.company_code,
            company.name,
            company.email_address,
            company.phone_number,
            company.address_line_one,
            company.address_line_two,
            company.pincode,
            company.state,
            company.city,
            company.address_line_one +
              ", " +
              company.address_line_two +
              ", " +
              company.city +
              "," +
              company.state +
              ", " +
              company.pincode +
              ", " +
              "India",
            company.is_deleted || false
          )
        );
      });
      setRows(rows);
      setLoader(false);
    }
  } catch (error) {
    console.log(error);
    setLoader(false);
  }
};

const EnhancedTableHead = (props) => {
  const { viewPermission, editPermission, deleteRestorePermission } = props;
  const [head, setHeads] = useState(headCells);

  useEffect(() => {
    let newHeads = [...headCells];
    if (viewPermission) {
      newHeads.push({ id: "view", alignment: "center", label: "View" });
    }
    if (editPermission) {
      newHeads.push({ id: "edit", alignment: "center", label: "Edit" });
    }
    if (deleteRestorePermission) {
      newHeads.push({ id: "actions", alignment: "center", label: "Actions" });
    }
    setHeads(newHeads);
  }, [viewPermission, editPermission, deleteRestorePermission]);

  return (
    <TableHead>
      <TableRow>
        {head.map((headCell) => (
          <TableCell
            key={headCell.id || headCell.key}
            align={headCell.alignment}
            padding={headCell.disablePadding ? "none" : "normal"}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const EnhancedTableToolbar = (props) => {
  const {
    sortingField,
    sortingOrder,
    setSortingField,
    setSortingOrder,
    search,
    setSearch,
    setFilter,
    rows,
    setOnSearch,
    csvPermission,
    includeDeleted,
    setIncludeDeleted,
  } = props;
  const navigate = useNavigate();

  let timestamp = moment().format("DD-MM-YY HH:mm");
  const csvRows = rows.map((row) => ({
    code: row.company_code,
    name: row.name,
    email: row.email,
    mobile: row.mobile,
    address: row.address,
  }));

  const csvReport = {
    filename: `AP_Companies_${timestamp}.csv`,
    headers: headCells,
    data: csvRows,
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        setOnSearch(true);
      }}
    >
      <Toolbar>
        <ToolbarTitle>
          <Typography variant="h6" id="tableTitle">
            Companies
          </Typography>
        </ToolbarTitle>
        <Spacer />

        {csvPermission && (
          <CSVLink
            style={{ color: "green", textDecoration: "none" }}
            {...csvReport}
          >
            <Button
              variant="outlined"
              sx={{ ml: 2, mr: 2 }}
              endIcon={<Download />}
            >
              CSV
            </Button>
          </CSVLink>
        )}

        <TextField
          value={search}
          size="small"
          style={{ width: "100%", marginRight: 10 }}
          label="Search"
          placeholder="Name/ Email/ Phone Number"
          onChange={(e) => setSearch(e.target.value)}
        />

        <Button
          endIcon={<SearchIcon />}
          style={{ width: "20%" }}
          variant="contained"
          type="submit"
        >
          Search
        </Button>

        <div>
          <ApCompanyFilter
            setFilter={setFilter}
            sortingField={sortingField}
            sortingOrder={sortingOrder}
            setSortingField={setSortingField}
            setSortingOrder={setSortingOrder}
            includeDeleted={includeDeleted}
            setIncludeDeleted={setIncludeDeleted}
          />
        </div>
        <Tooltip title="Register Company">
          <IconButton>
            <AddIcon
              onClick={() =>
                navigate("/dashboard/company/ap-companies/create-ap-company/")
              }
            />
          </IconButton>
        </Tooltip>
      </Toolbar>
    </form>
  );
};

function EnhancedTable({
  sortingField,
  sortingOrder,
  setSortingField,
  setSortingOrder,
  search,
  setSearch,
  setFilter,
  rows,
  viewPermission,
  editPermission,
  deleteRestorePermission,
  setOnSearch,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
  rowsPerPage,
  total_results,
  csvPermission,
  includeDeleted,
  setIncludeDeleted,
  refreshList,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [message, setMessage] = useState(location?.state?.message);
  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [actionType, setActionType] = useState(null); // 'delete' or 'restore'

  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  useEffect(() => {
    if (location?.state?.success) {
      snackRef.current.click();
      navigate(location.pathname, { replace: true });
    }
  }, [location?.state]);

  const handleDeleteRestoreClick = (company, type) => {
    setSelectedCompany(company);
    setActionType(type);
    setOpenConfirm(true);
  };

  const handleConfirm = async () => {
    setOpenConfirm(false);
    if (!selectedCompany) return;
    const token = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + token.access_token,
      },
    };
    try {
      let response;
      if (actionType === "delete") {
        response = await axios.delete(
          `/api/v1/${token.type}/ap_company/${selectedCompany.id}`,
          config
        );
      } else if (actionType === "restore") {
        response = await axios.put(
          `/api/v1/${token.type}/ap_company/${selectedCompany.id}/restore`,
          {},
          config
        );
      }
      if (response.data.success) {
        setMessage(response.data.message);
        snackRef.current.click();
        refreshList(); // re-fetch current page
      }
    } catch (error) {
      console.error(error);
      const errorMsg = error.response?.data?.error || "Operation failed";
      setMessage(errorMsg);
      snackRef.current.click();
    }
  };

  return (
    <div>
      <Button
        ref={snackRef}
        style={{ display: "none" }}
        onClick={handleClick({ vertical: "top", horizontal: "center" })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        key={vertical + horizontal}
        autoHideDuration={4000}
      >
        <Alert mt={2} mb={4} severity={message?.includes("successfully") ? "success" : "error"}>
          {message}
        </Alert>
      </Snackbar>

      <Paper>
        <EnhancedTableToolbar
          setOnSearch={setOnSearch}
          setFilter={setFilter}
          sortingField={sortingField}
          sortingOrder={sortingOrder}
          setSortingField={setSortingField}
          setSortingOrder={setSortingOrder}
          search={search}
          setSearch={setSearch}
          rows={rows}
          csvPermission={csvPermission}
          includeDeleted={includeDeleted}
          setIncludeDeleted={setIncludeDeleted}
        />
        <StyledTableContainer>
          <Table size={"small"}>
            <EnhancedTableHead
              rowCount={rows.length}
              viewPermission={viewPermission}
              editPermission={editPermission}
              deleteRestorePermission={deleteRestorePermission}
            />
            <TableBody>
              {rows.map((row, index) => {
                const TableRowComponent = row.is_deleted ? DeletedTableRow : TableRow;
                return (
                  <TableRowComponent
                    role="checkbox"
                    tabIndex={-1}
                    key={`${row.id}-${index}`}
                  >
                    <TableCell align="left">{row.company_code}</TableCell>
                    <TableCell align="left">{row.name}</TableCell>
                    <TableCell align="left">{row.email}</TableCell>
                    <TableCell align="left">{row.mobile}</TableCell>
                    <TableCell align="left">{row.address}</TableCell>
                    {viewPermission && (
                      <TableCell align="center">
                        <VisibilityIcon
                          style={{ cursor: "pointer", color: "green" }}
                          onClick={() =>
                            navigate(
                              `/dashboard/company/ap-companies/${row.id}`,
                              { state: { id: row.id } }
                            )
                          }
                        />
                      </TableCell>
                    )}
                    {editPermission && (
                      <TableCell align="center">
                        <EditIcon
                          style={{ cursor: "pointer", color: "red" }}
                          onClick={() =>
                            navigate(
                              `/dashboard/company/ap-companies/update-ap-company/${row.id}`,
                              { state: { id: row.id } }
                            )
                          }
                        />
                      </TableCell>
                    )}
                    {deleteRestorePermission && (
                      <TableCell align="center">
                        {!row.is_deleted ? (
                          <Tooltip title="Soft Delete">
                            <IconButton
                              onClick={() =>
                                handleDeleteRestoreClick(row, "delete")
                              }
                              size="small"
                            >
                              <DeleteIcon color="error" />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip title="Restore">
                            <IconButton
                              onClick={() =>
                                handleDeleteRestoreClick(row, "restore")
                              }
                              size="small"
                            >
                              <RestoreFromTrashIcon color="primary" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </TableCell>
                    )}
                  </TableRowComponent>
                );
              })}
            </TableBody>
          </Table>
        </StyledTableContainer>
        <TablePagination
          rowsPerPageOptions={[50, 100, 250]}
          component="div"
          count={total_results}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      {/* Confirmation Dialog */}
      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>
          {actionType === "delete" ? "Delete Company" : "Restore Company"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {actionType === "delete"
              ? `Are you sure you want to soft delete company "${selectedCompany?.name}"? It can be restored later.`
              : `Are you sure you want to restore company "${selectedCompany?.name}"?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)}>Cancel</Button>
          <Button onClick={handleConfirm} color={actionType === "delete" ? "error" : "primary"} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

function ApCompanies({ auths }) {
  const token = JSON.parse(localStorage.getItem("AuthData"));
  const [loader, setLoader] = useState(true);
  const [rows, setRows] = useState([]);
  const [viewPermission, setViewPermission] = useState(false);
  const [editPermission, setEditPermission] = useState(false);
  const [csvPermission, setCsvPermission] = useState(false);
  const [deleteRestorePermission, setDeleteRestorePermission] = useState(false);

  const authData = JSON.parse(localStorage.getItem("AuthData"));
  const [sortingField, setSortingField] = useState("updated_at");
  const [sortingOrder, setSortingOrder] = useState("desc");
  const location = useLocation();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const [search, setSearch] = useState(searchParams.get("search_keyword") || "");
  const [onSearch, setOnSearch] = useState(false);
  const [filter, setFilter] = useState(true);
  const [includeDeleted, setIncludeDeleted] = useState(
    searchParams.get("include_deleted") || "NO"
  );

  const [page, setPage] = useState(
    searchParams.get("page") ? Number(searchParams.get("page")) : 0
  );
  const [rowsPerPage, setRowsPerPage] = useState(
    searchParams.get("limit") ? Number(searchParams.get("limit")) : 50
  );
  const [total, setTotal] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Refresh function to re-fetch the current list
  const refreshList = () => {
    setFilter(true);
  };

  useEffect(() => {
    if (
      auths?.user?.role?.permissions.includes("view_ap_company_profile") ||
      authData?.type === "super_admin"
    ) {
      setViewPermission(true);
    }
    if (
      ["view_ap_company_profile", "update_ap_company"].every((k) =>
        auths?.user?.role?.permissions.includes(k)
      ) ||
      authData?.type === "super_admin"
    ) {
      setEditPermission(true);
    }
    if (
      auths?.user?.role?.permissions.includes("download_csv") ||
      authData?.type === "super_admin"
    ) {
      setCsvPermission(true);
    }
    // Only super_admin can delete/restore according to backend
    if (authData?.type === "super_admin" || auths?.user?.role?.permissions.includes("delete_ap_company") || auths?.user?.role?.permissions.includes("restore_ap_company")) {
      setDeleteRestorePermission(true);
    }
  }, [auths.user, authData]);

  useEffect(() => {
    let sorting_order = sortingOrder;
    let sorting_field = sortingField;
    let sk = search || "";
    let inclDel = includeDeleted;

    if (filter || onSearch) {
      let sf = sorting_field || sortingField;
      let so = sorting_order || sortingOrder;

      navigate(
        `/dashboard/company/ap-companies?sorting_field=${sf}&sorting_order=${so}&search_keyword=${sk}&page=${page}&limit=${rowsPerPage}&include_deleted=${inclDel}`,
        { replace: true }
      );
      getCompanies(
        token,
        setLoader,
        setRows,
        sf,
        so,
        sk,
        page,
        rowsPerPage,
        setTotal,
        inclDel
      );
      setSearch(sk);
      setSortingField(sf);
      setSortingOrder(so);
      setFilter(false);
      setOnSearch(false);
    } else {
      navigate(
        `/dashboard/company/ap-companies?sorting_field=${sortingField}&sorting_order=${sortingOrder}&search_keyword=${search}&page=${page}&limit=${rowsPerPage}&include_deleted=${includeDeleted}`,
        { replace: true }
      );
      getCompanies(
        token,
        setLoader,
        setRows,
        sortingField,
        sortingOrder,
        search,
        page,
        rowsPerPage,
        setTotal,
        includeDeleted
      );
      setFilter(false);
      setOnSearch(false);
    }
  }, [filter, page, rowsPerPage, onSearch, includeDeleted]);

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              AP COMPANIES
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Typography>AP Companies</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <EnhancedTable
              setOnSearch={setOnSearch}
              setFilter={setFilter}
              sortingField={sortingField}
              sortingOrder={sortingOrder}
              setSortingField={setSortingField}
              setSortingOrder={setSortingOrder}
              search={search}
              setSearch={setSearch}
              viewPermission={viewPermission}
              editPermission={editPermission}
              deleteRestorePermission={deleteRestorePermission}
              rows={rows}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              rowsPerPage={rowsPerPage}
              total_results={total}
              csvPermission={csvPermission}
              includeDeleted={includeDeleted}
              setIncludeDeleted={setIncludeDeleted}
              refreshList={refreshList}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});
export default connect(mapStateToProps, null)(ApCompanies);